import openInClientStore from '../openInClientStore';
import strings from 'owa-strings/owa-extensibility-strings';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { isInClientStoreEnabled } from 'owa-addins-feature-flags';
import { logUsage } from 'owa-analytics';

export default async function showGDPRMinorDialog() {
    const result = await confirm(
        strings.gdprMinorDialogTitleText,
        strings.gdprMinorWarningText,
        false /* resolveImmediately */,
        {
            okText: strings.gdprMinorDialogOKButtonText,
            cancelText: strings.gdprMinorRemoveAddinText,
        }
    );

    logUsage('ExtGDPRMinorDialogResponse', [result]);
    if (result === DialogResponse.cancel && isInClientStoreEnabled()) {
        openInClientStore();
    }
}
